import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { environment } from '@env/environment';
import { AuthenticationService } from '@shared/services/authentication.service';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { Router } from '@angular/router';
import { Course } from '@shared/models/course.model';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { filter } from 'rxjs/operators';

@Component({
  selector: './lms-dialog.component',
  templateUrl: './lms-dialog.component.html',
  styleUrls: ['./lms-dialog.component.scss']
})
export class LMSDialogComponent implements OnInit {
  scormLink: string;
  ltilaunch: string;
  ltiEnabled = false;
  xAPIForm: FormGroup;
  constructor(
    private _router: Router,
    private _authService: AuthenticationService,
    private dialogRef: MatDialogRef<LMSDialogComponent>,
    private _courseAPIService: CoursesAPIService,
    private _currentHubService: CurrentHubService,
    @Inject(MAT_DIALOG_DATA) public data: { course: Course }
  ) {

  }
  ngOnInit(): void {
    this.dialogRef.updateSize('40vw', '50vh');
    // Check LTI is enabled at Hub level
    this._currentHubService.hubObservable.pipe(
      filter(hub => hub != null)
    ).subscribe(hub => {
      this.ltiEnabled = hub.lti_enabled;
    });
    this.scormLink = environment.coursesApiUrl + '/api/courses/' + this.data.course.id + '/exportScorm';
    this.ltilaunch = environment.coursesApiUrl + '/api/lti/' + this.data.course.id;
    this.xAPIForm = new FormGroup(
      {
        information: new FormGroup({
          externalXAPI: new FormGroup({
            xapi_endpoint: new FormControl(''),
            xapi_key: new FormControl(''),
            xapi_secret: new FormControl('')
        })
      })
      }
    );
    this.xAPIForm.reset(this.data.course, { emitEvent: false });
  }
  onSave(): void {
    this.data.course.information.externalXAPI = this.xAPIForm.value.information.externalXAPI;
    this._courseAPIService.updateCourse(this.data.course.id, { information: this.data.course.information }).subscribe(() => {
      this.dialogRef.close();
    });
  }
  onClose(): void {
    this.dialogRef.close();
  }
  goToHelp(url: string): void {
    window.open(url);
  }
}
